import styled from 'styled-components';
import { Breakpoints } from '../../../../../styled/constants';

export const ReportSectionList = styled.div`
  > label {
    padding: 0 5px 0 0;
    height: 60px;

    > span {
      font-size: 15px;
    }

    &::after {
      height: 0;
    }

    @media (min-width: ${Breakpoints.tablet}px) {
      padding: 0 10px;
    }
  }

  @media (min-width: ${Breakpoints.tablet}px) {
    padding: 0 20px;
  }
`;
